import React from "react";
import { useTranslation } from "@repo/translation";
import { Controller } from "react-hook-form";
import { Button } from "../../atoms/button";
import { ValueInput } from "../../atoms/valueInput";
import { If } from "../../atoms/if";
import { DrawerSectionTitle } from "../../atoms/drawerSectionTitle";
import { StyledAlertWrapper } from "../../organisms/WithdrawBankAccountList/styles";
import InformationIcon from "../../../images/icon_information.svg";
import WarningIcon from "../../../images/warning.svg";
import BasicAlert from "../../molecules/basicAlert";

const DEFAULT_AMOUNT = 50;

export const WithdrawStepAmount = ({
  isLoading,
  errors,
  currencySymbol,
  control,
  availableBalance,
  minimumAmount,
  maximumAmount,
  hasNoWithdrawalAccount,
  isContinueDisabled,
  onContinue,
}) => {
  const { translate } = useTranslation();

  const validateAmount = (value) => {
    if (!value) return true;

    const isBelowMinimum = value < minimumAmount && value !== 0;
    const isAboveBalance = value > availableBalance;
    const isAboveMaximum = value > maximumAmount;

    if (isBelowMinimum) {
      return `${translate(
        "payments.minimumWithdrawalAmount",
      )} ${currencySymbol}${minimumAmount}`;
    }

    if (isAboveBalance) {
      return translate("payments.withdraw.notEnoughBalance");
    }

    if (isAboveMaximum) {
      return `${translate(
        "payments.maximumWithdrawalAmount",
      )} ${currencySymbol}${maximumAmount}`;
    }

    return true;
  };

  return (
    <>
      <section>
        <DrawerSectionTitle title={translate("payments.withdraw.howMuch")} />

        <p>
          {translate("payments.withdraw.availableBalance")?.replace(
            "{0}",
            `${currencySymbol}${availableBalance}`,
          )}
        </p>
        <Controller
          name="withdrawAmount"
          control={control}
          rules={{
            required: true,
            validate: validateAmount,
          }}
          render={({ field }) => (
            <ValueInput
              {...field}
              placeholder={DEFAULT_AMOUNT}
              currencySymbol={currencySymbol}
              errors={errors?.withdrawAmount}
              disabled={false}
            />
          )}
        />

        <If
          condition={hasNoWithdrawalAccount}
          render={() => (
            <StyledAlertWrapper>
              <BasicAlert
                mobileIcon={WarningIcon}
                desktopIcon={InformationIcon}
                description={translate("addBankAccount.salaryAccountWarning")}
              />
            </StyledAlertWrapper>
          )}
        />
      </section>

      <Button
        expand
        disabled={isContinueDisabled}
        id="btnWithdrawalContinue"
        loading={isLoading}
        className="btn-cta"
        onClick={onContinue}
        type="button"
      >
        {translate("common.continue")}
      </Button>
    </>
  );
};
